"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = exports.ContextMenuEvent = void 0;
const query_1 = require("./query");
class ContextMenuEvent extends MouseEvent {
    constructor(type, contextTarget, contextMenu, menuItem, me) {
        super(type, me);
        this.contextTarget = contextTarget;
        this.contextMenu = contextMenu;
        this.menuItem = menuItem;
        this.data = {};
        Object.keys(this.contextTarget.dataset)
            .forEach(key => {
            this.data[key] = this.contextTarget.dataset[key];
        });
    }
}
exports.ContextMenuEvent = ContextMenuEvent;
class ContextMenu {
    static for(selector, opts) {
        let element;
        if (typeof selector === 'string')
            element = document.querySelector(selector);
        else if (selector instanceof HTMLElement)
            element = selector;
        if (!element)
            return null;
        if (query_1.Z.getData(element, 'context-menu'))
            return query_1.Z.getData(element, 'context-menu');
        query_1.Z.setData(element, 'context-menu', new ContextMenu(element, opts));
    }
    constructor(el, opts = {}) {
        this.element = el;
        el.addEventListener('context-menu-shown', (ev) => this.onContextMenuShown(ev));
        if (opts.actions)
            Object.keys(opts.actions)
                .forEach(action => {
                el.addEventListener(`context-menu:${action}`, (ev) => {
                    if (this.creationOptions.caller) {
                        opts.actions[action].call(this.creationOptions.caller, ev);
                    }
                    else {
                        opts.actions[action](ev);
                    }
                    el.classList.remove('active');
                });
            });
        this.creationOptions = opts;
    }
    onContextMenuShown(ev) {
        if (!this.creationOptions)
            return;
        if (!this.creationOptions.onShown)
            return;
        if (this.creationOptions.caller) {
            this.creationOptions.onShown.call(this.creationOptions.caller, ev);
        }
        else {
            this.creationOptions.onShown(ev);
        }
    }
    show(element) {
        let contextMenu = this.element;
        if (!element || !contextMenu)
            return;
        this.element.classList.add('active');
        query_1.Z.setData(contextMenu, 'context-menu-source', element);
        contextMenu.classList.add('active');
        contextMenu.dispatchEvent(new ContextMenuEvent('context-menu-shown', element, contextMenu, null, new MouseEvent('mousedown')));
        let bounds = element.getBoundingClientRect();
        let x = bounds.left;
        let y = bounds.bottom;
        let w = contextMenu.getBoundingClientRect().width;
        let h = contextMenu.getBoundingClientRect().height;
        if (x < 0)
            x = 0;
        if (y < 0)
            y = 0;
        if (x + w >= window.innerWidth)
            x = window.innerWidth - w;
        if (y + h >= window.innerHeight)
            y = window.innerHeight - h;
        contextMenu.style.left = x + 'px';
        contextMenu.style.top = y + 'px';
    }
}
exports.ContextMenu = ContextMenu;
//# sourceMappingURL=contextMenuControl.js.map